import { render, staticRenderFns } from "./AntimatterDimensionProgressBar.vue?vue&type=template&id=ef739282"
import script from "./AntimatterDimensionProgressBar.vue?vue&type=script&lang=js"
export * from "./AntimatterDimensionProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports